import { render, staticRenderFns } from "./VideoCommentList.vue?vue&type=template&id=173d6510&scoped=true"
import script from "./VideoCommentList.vue?vue&type=script&lang=js"
export * from "./VideoCommentList.vue?vue&type=script&lang=js"
import style0 from "./VideoCommentList.vue?vue&type=style&index=0&id=173d6510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173d6510",
  null
  
)

export default component.exports